import { render, staticRenderFns } from "./GDropdown.vue?vue&type=template&id=d3eed728&scoped=true"
import script from "./GDropdown.vue?vue&type=script&lang=ts"
export * from "./GDropdown.vue?vue&type=script&lang=ts"
import style0 from "./GDropdown.vue?vue&type=style&index=0&id=d3eed728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3eed728",
  null
  
)

export default component.exports